import cfiLogic from '../cfiLogic';

/**
 * @method orderUserContentByCfi
 */
const orderUserContentByCfi = (frame, document, ...userContentArrays) => {
  // Allow passing in multiple arrays of user content
  const combinedUserContentArray = [].concat(
    ...userContentArrays.map((userContentArray) => userContentArray ?? []),
  );

  const orderedUserContent = combinedUserContentArray.sort((a, b) => {
    // If documents don't match, that's most important and easiest to determine.
    if (a.bookLocation.document.index !== b.bookLocation.document.index) {
      return a.bookLocation.document.index - b.bookLocation.document.index;
    }

    // Assuming documents match, if they are not the current document we cannot compare cfis.
    if (a.bookLocation.document.index !== document.index) {
      return 0;
    }

    let cfiA = a.bookLocation.cfi;
    let cfiB = b.bookLocation.cfi;

    if (!cfiA && a.bookLocation.element) {
      cfiA = cfiLogic.getCfiForElement(
        frame.contentDocument,
        a.bookLocation.page.element,
      );
    }

    if (!cfiB && b.bookLocation.element) {
      cfiB = cfiLogic.getCfiForElement(
        frame.contentDocument,
        b.bookLocation.page.element,
      );
    }

    if (!cfiA || !cfiB) {
      // Cannot compare without CFIs.
      return 0;
    }

    try {
      return cfiLogic.compareCfiRanges(frame.contentDocument, cfiA, cfiB);
    } catch (error) {
      console.warn('Failed to sort content by cfi', error, cfiA, cfiB);
      return 0;
    }
  });

  return orderedUserContent;
};

export default orderUserContentByCfi;
